import React from "react";

const ModalBootstrap = ({
  previewContent,
  modalTitle,
  modalContent,
  modalCloseText = "閉じる",
  isMaxWidth = false,
}) => {
  return (
    <React.Fragment>
      {/* Button trigger modal */}
      <div data-toggle="modal" data-target="#exampleModalLong">
        {previewContent}
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="exampleModalLong"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div
          style={isMaxWidth ? { maxWidth: "none", margin: "0.5rem" } : {}}
          className="modal-dialog"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                {modalTitle}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">{modalContent}</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                {modalCloseText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ModalBootstrap;
